import * as React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

// Components
import { Tooltip } from '../../../../../../../../../components/Tooltip';

const WrapperStyle = css`
    border: ${({ overridable, noborder }) => (!overridable || noborder ? 'none' : '1px solid #ddd')};
    border-radius: ${({ overridable, noborder }) => (!overridable || noborder ? '0' : '4px')};
    ${({ isempty }) =>
        isempty === 'true' &&
        css`
            ${'' /* font-size: 0.8rem; */}
            border-color: #e9dbad;
            color: #e69b2d;
        `}
`;

const CompountWrapper = styled.div`
    display: flex;
    ${WrapperStyle}
`;
const PlainRenderElement = styled.div`
    padding: 4px 8px;
    border-left: ${({ borderleft }) => (borderleft === 'true' ? '1px solid #ddd !important' : 'none')};
    ${WrapperStyle}
`;

export const PlainRenderInputElement = ({ placeholderPartial, compound, borderleft, value, overridable }) => {
    const isValueUnset = typeof value === 'undefined' || value === '';

    return (
        <Tooltip title={'Overridable'} trigger="mouseenter" delay={[1000, 0]} arrow={true} disabled={!overridable}>
            <PlainRenderElement
                overridable={overridable}
                noborder={compound}
                borderleft={overridable && borderleft}
                isempty={(!overridable && isValueUnset).toString()}
            >
                {!isValueUnset ? value : `[${placeholderPartial} unset]`}
            </PlainRenderElement>
        </Tooltip>
    );
};

export default PlainRenderInputElement;

const PlainRenderInputElementProps = {
    placeholderPartial: PropTypes.string,
    value: PropTypes.any,
    overridable: PropTypes.bool,
    compound: PropTypes.bool,
    borderleft: PropTypes.string
};
PlainRenderInputElement.propTypes = {
    ...PlainRenderInputElementProps
};

export const PlainRenderElementsWrapper = ({ items, overridable }) => {
    return (
        <CompountWrapper overridable={overridable}>
            {items.map((item, index) => (
                <PlainRenderInputElement
                    compound={true}
                    key={index}
                    {...item}
                    borderleft={(index !== 0).toString()}
                    overridable={overridable}
                />
            ))}
        </CompountWrapper>
    );
};

PlainRenderElementsWrapper.propTypes = {
    overridable: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.shape({ ...PlainRenderInputElementProps }))
};
